import angular from 'angular';
import moment from 'angular-moment';

import chartConfig from './compare-graph-daily.config';
import DateUtil from '../../../../components/logic/date_util/date_util.module';
import DemandPowerService from '../../../../components/api/demand_power/demand_power.service';
import PowerFormatter from '../../../../components/logic/power-formatter/power-formatter.logic';

export class CompareGraphDailyDemandController {
  /*@ngInject*/
  constructor($filter, $interval, $q, $scope, moment, DateUtil, DemandPowerService, PowerFormatter) {
    this.$interval = $interval;
    this.$filter = $filter;
    this.$q = $q;
    this.moment = moment;
    this.DateUtil = DateUtil;
    this.DemandPowerService = DemandPowerService;
    this.PowerFormatter = PowerFormatter;
    this.graphUpdating = false;

    this.categories = DateUtil.getXLabels; // ['00:30', '00:30', ... '00:00']
    this.maxDate = moment().startOf('day').toDate();
    this.seriesList = [];

    this.chartConfig = chartConfig(this);

    $scope.$watch('$ctrl.selectedConfigs', () => this.updateGraph(this.targetDate));
    $scope.$watch('$ctrl.targetDate', () => this.updateGraph(this.targetDate));
  }

  $onInit() {
    this.timer = this.$interval(() => {
      this.updateGraph(this.targetDate);
    }, 300000);
  }

  updateGraph(targetDate) {
    if (this.chart) {
      this.chart.reflow();
    }
    if (this.selectedConfigs.length === 0) {
      return;
    }
    this.graphUpdating = true;
    this.resetSeries();

    const promises = [];
    for (let config of this.selectedConfigs) {
      promises.push(this.getDemandData(config, targetDate));
    }

    this.$q.all(promises).then(results => {
      for (let result of results) {
        this.addSeries(result.demandPowers, result.config);
      }
      this.chart.redraw();
      this.chart.reflow();
      this.graphUpdating = false;
    });
  }

  getDemandData(config, targetDate) {
    const dateQuery = this.DateUtil.getQueryParams(targetDate);
    const query = angular.extend({id: config.id}, dateQuery);

    return new Promise(resolve => {
      this.DemandPowerService.show(query, res => {
        const [demandPowers,] = this.PowerFormatter.formatDemandPowers(res.powers, targetDate, this.categories);
        resolve({demandPowers, config});
      });
    });
  }

  addSeries(powers, config) {
    if (!powers) { return; }
    const graphData = this.categories.map((e, i) => {
      return [e, powers[i]];
    });
    this.chart.addSeries({
      name: config.pms_service_code,
      type: this.graphType,
      data: graphData
    }, false);
  }

  resetSeries() {
    if (!this.chart) { return; }
    while(this.chart.series.length > 0) {
      this.chart.series[0].remove(false);
    }
  }

  changeDate(diff) {
    if (diff) {
      this.updateTargetDate({targetDate: this.DateUtil.leapDate(this.targetDate, diff)});
    }
  }
}

export default angular.module('leptonApp.compareGraphDailyDemand', [moment, DateUtil, DemandPowerService, PowerFormatter])
  .component('compareGraphDailyDemand', {
    template: require('./compare-graph-daily.html'),
    controller: CompareGraphDailyDemandController,
    bindings: {
      selectedConfigs: '=',
      configIds: '=',
      graphType: '=',
      targetDate: '=',
      updateTargetDate: '&'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/compare-graph/demand/daily/compare-graph-daily.component.js